import { render } from "./UpdateFormNew.vue?vue&type=template&id=5ef8b45a&scoped=true"
import script from "./UpdateFormNew.vue?vue&type=script&lang=js"
export * from "./UpdateFormNew.vue?vue&type=script&lang=js"

import "./UpdateFormNew.vue?vue&type=style&index=0&id=5ef8b45a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef8b45a"]])

export default __exports__